import { Popper } from '@mui/material';
import { useEffect, useRef } from 'react';

export const CustomPopper = (props: any) => {
  const popperRef = useRef(null);
  const { setOpenPopper, ...restProps } = props;
  useOutsideAlerter(popperRef);

  function useOutsideAlerter(ref: any) {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpenPopper(false);
        }
      }
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  }

  return <Popper {...restProps} ref={popperRef} />;
};
